"use client"

import { createContext, PropsWithChildren, useContext, useState } from "react";

type StepNumber = 1 | 2 | 3 

type Step = {
    number: StepNumber;
    isCompleted: boolean;
}

const initialStepsList: Step[] = [
    {
        number: 1,
        isCompleted: false,
    },
    {
        number: 2,
        isCompleted: false,
    },
    {
        number: 3,
        isCompleted: false,
    },
]

type SignupFormStepsContextType = {
    currentStep: Step;
    stepsList: Step[];
    updateStepsCompleted: (steps: StepNumber[]) => void;
    updateCurrentStep: (steps: StepNumber) => void;
    /** True when OTP was sent after registration; form fields should be hidden and only OTP input shown */
    registrationOtpSent: boolean;
    setRegistrationOtpSent: (value: boolean) => void;
}

const SignupFormStepsContext = createContext<SignupFormStepsContextType | null>(null);

export const SignupFormStepsProvider = ({ children }: PropsWithChildren) => {
    
    const [stepsList, setStepsList] = useState<Step[]>(initialStepsList)
    
    const [currentStep, setCurrentStep] = useState<Step>(stepsList[0])

    const [registrationOtpSent, setRegistrationOtpSent] = useState(false)

    const updateStepsCompleted = (steps: StepNumber[] | StepNumber) => {
        setStepsList((prev) => {
            if (Array.isArray(steps)) {
                steps.forEach(step => {
                    prev[step - 1].isCompleted = true 
                })
            } else {
                prev[steps - 1].isCompleted = true 
            }
            return prev
        })
    }

    const updateCurrentStep = (step: StepNumber) => {
        setCurrentStep(stepsList[step - 1])
    }

    return (
        <SignupFormStepsContext.Provider value={{
            currentStep,
            updateStepsCompleted,
            updateCurrentStep,
            stepsList,
            registrationOtpSent,
            setRegistrationOtpSent,
        }}>
            {children}
        </SignupFormStepsContext.Provider>
    )
}


export const useSignupFormStepsContext = () => {
    const context = useContext(SignupFormStepsContext);
    if (!context) {
        throw new Error('useSignupFormContext must be used within SignupFormProvider');
    }
    return context;
}

